import React, { useState, useEffect } from 'react'
import { Modal, Form, Radio, Input, Spin, App, Space } from 'antd';
import Icon from '../../cpn/Icon';
import { useJKbohuiMutation, useJKupdatecontentMutation } from '../../store/DianShangYeWuApi';

function LoanNodeCheckEdit(props) {
    const {message} = App.useApp();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [updateIsFetching, setUpdateIsFetching] = useState(false);
    const [bohui] = useJKbohuiMutation();
    const [updateContent] = useJKupdatecontentMutation();
    useEffect(() => {              
        form.setFieldsValue({
            jk_sp_state: props.jk_sp_state ==='4'?'4':'3',
            jk_sp_content: props.jk_sp_content,
        });
    }, [
        props.jk_sp_id, 
        props.jk_sp_jd_xuhao, 
        props.jk_sp_jd_name, 
        props.jk_sp_yh_id, 
        props.jk_sp_yh_name, 
        props.jk_sp_uid, 
        props.jk_sp_uname, 
        props.jk_sp_state, 
        props.jk_sp_content, 
        props.sortedData,
        props.jk_sp_state_time,
        form
    ]);
    return (
        <>
            <Space orientation='vertical' size={1}>
                <span style={{color:props.jk_sp_state==='4' ? 'red' : 'green',fontWeight:"bold"}}>
                    {props.jk_sp_state==='4' ? '已驳回' : '已同意'}
                    {props.jk_sp_content? '：'+props.jk_sp_content :''}
                </span>
                <span>{props.yh_name} {props.jk_sp_state_time} </span>
                <Icon type="edit"  onClick={() => {setOpen(true);}} title='修改审批说明'/>
            </Space>
            <Modal 
                open={open} 
                onCancel={() => {
                    setOpen(false);
                    setUpdateIsFetching(false);
                }} 
                footer={null}
                title='审批借款单'
            >
                <Spin spinning={updateIsFetching} tip="审批中...">
                    <Form
                        form={form}
                        name="form_loan"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 5}}
                        wrapperCol={{ span: 19 }}
                        onFinish={(value) => {
                            if((value.jk_sp_state === '3' && props.jk_sp_state === '3') || (value.jk_sp_state === '4' && props.jk_sp_state === '4') || (value.jk_sp_state === '3' && props.jk_sp_state==='5')){
                                updateContent({
                                    'jk_sp_id': props.jk_sp_id,
                                    'jk_sp_content': value.jk_sp_content,
                                    'jk_sp_yh_id': props.jk_sp_yh_id,
                                    'jk_sp_yh_name': props.jk_sp_yh_name
                                }).then((res) => {
                                    if(res.data.Status === 'success'){
                                        message.success('审批说明修改成功');
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }else{
                                        message.error('审批说明修改失败'+res.data.Message);
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }
                                });
                                return;                            
                            }else if(value.jk_sp_state === '4' &&  props.jk_sp_state === '3'){
                                bohui({
                                    'jk_sp_id': props.jk_sp_id,
                                    'jk_id': props.jk_id,
                                    'jk_sp_yh_id': props.jk_sp_yh_id,
                                    'jk_sp_content': value.jk_sp_content
                                }).then((res) => {
                                    if(res.data.Status === 'success'){
                                        message.success('驳回成功');
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }else{
                                        message.error('驳回失败'+res.data.Message);
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }
                                });
                            }else{
                                console.log(props.jk_sp_state, value.jk_sp_state);
                                
                                if(props.jk_sp_state === '5' && value.jk_sp_state === '4'){
                                    message.error('已结束的单据不能驳回！')
                                }else if(props.jk_sp_state === '4' && value.jk_sp_state === '3'){
                                    message.error('已驳回的单据不能同意审批！')
                                }
                                setUpdateIsFetching(false);
                            }
                         
                        }}
                    >                    
                    <Form.Item name="jk_sp_state" label="审批意见">
                        <Radio.Group disabled>
                            <Radio value="3">同意</Radio>
                            <Radio value="4">驳回</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item name="jk_sp_content" label="说明">
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 5, span: 19 }}>
                        <Icon type="save"  onClick={() => {
                            // 弹出加载中Spin
                            setUpdateIsFetching(true);
                            form.submit();
                        }}/>
                    </Form.Item>
                </Form>
                </Spin>
            </Modal>
        </>
    )
}

export default LoanNodeCheckEdit